import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import CodeReglementaire from './CodeReglementaire';

import TimerGuard from './TimerGuard';

// Composant de layout pour les pages principales de l'application

const PagesLayout: React.FC = () => {
    // État pour stocker la largeur et la hauteur actuelles de .siteWrapper
    const [dimensions, setDimensions] = useState({ width: 640, height: 1136 });

    useEffect(() => {
        const updateDimensions = () => {
            const viewportWidth = document.documentElement.clientWidth; // Exclut la barre de défilement
            const windowHeight = window.innerHeight;

            const widthScaleFactor = viewportWidth / 640;
            const heightScaleFactor = windowHeight / 1136;

            const scaleFactor = Math.min(widthScaleFactor, heightScaleFactor);

            // Mettez à jour la taille de police basée sur le scaleFactor
            document.documentElement.style.setProperty(
                '--scale-font-size',
                `${33 * scaleFactor}px`,
            );

            setDimensions({
                width: 640 * scaleFactor,
                height: 1136 * scaleFactor,
            });
        };
        // Appeler updateDimensions au montage pour initialiser les dimensions
        updateDimensions();

        // Ajouter un écouteur d'événement pour les changements de taille de la fenêtre
        window.addEventListener('resize', updateDimensions);

        // Nettoyer l'écouteur d'événement lors du démontage du composant
        return () => {
            window.removeEventListener('resize', updateDimensions);
        };
    }, []);
    return (
        <div className='main-container'>
            <div
                className='siteWrapper'
                style={{
                    width: `${dimensions.width}px`,
                    height: `${dimensions.height}px`,
                }}
            >
                <TimerGuard />
                <Outlet />
                <CodeReglementaire />
            </div>
        </div>
    );
};

export default PagesLayout;
